import { Box } from "@mui/material";

import ImgBg from "../../assets/images/products/index-lab.svg";
import Select from "../Select";

interface Props {
  title: string;
  returnValue: number;
  volatility: number;
}

const IndexLabCard: React.FC<Props> = ({ title, returnValue, volatility }) => {
  const handleChange = () => {};

  return (
    <Box
      sx={{
        minHeight: 360,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundImage: `url(${ImgBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPositionX: "center",
        backgroundPositionY: "center",
        padding: "2rem",
      }}
    >
      <Box sx={{ fontSize: 30, lineHeight: 1.2, fontWeight: 600 }}>{title}</Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Select
            label=""
            options={[
              { label: "Get Started", value: "get_started" },
              { label: "Download Factsheet", value: "download_factsheet" },
              { label: "Download PIM", value: "download_pim" },
              {
                label: "Download Price Series",
                value: "download_price_series",
              },
            ]}
            value="get_started"
            variant="filled"
            width={200}
            disableUnderline
            onChange={handleChange}
          />
        </Box>
        <Box>
          <Box
            sx={{
              width: 150,
              border: "1px solid #fff",
              textAlign: "center",
              paddingY: "0.25rem",
            }}
          >
            <Box sx={{ fontSize: 16, lineHeight: 1.2, fontWeight: 600 }}>
              1-Yr Return
            </Box>
            <Box sx={{ fontSize: 16, lineHeight: 1.2 }}>{returnValue}%</Box>
          </Box>
          <Box
            sx={{
              width: 150,
              border: "1px solid #fff",
              textAlign: "center",
              paddingY: "0.25rem",
              marginTop: "0.5rem",
            }}
          >
            <Box sx={{ fontSize: 16, lineHeight: 1.2, fontWeight: 600 }}>
              1-Yr Volatility
            </Box>
            <Box sx={{ fontSize: 16, lineHeight: 1.2 }}>{volatility}%</Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default IndexLabCard;
